import * as Yup from 'yup';
import { email } from 'validation';

export default Yup.object({
  email
});
